import { render, staticRenderFns } from "./AddGroupDlg.vue?vue&type=template&id=6ee60712&"
import script from "./AddGroupDlg.vue?vue&type=script&lang=js&"
export * from "./AddGroupDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports